import React, { useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  CircularProgress,
  Box,
  TableContainer,
  Table,
  Paper,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { fetchPreOrderDetails } from "../../commandes/slices/detailOrderSlice";
import { formatPrice } from "../../../utils/formatPrice";

interface PreOrderDetailsModalProps {
  open: boolean;
  handleClose: () => void;
  preOrderId: string | null;
}

const PreOrderDetailsModal: React.FC<PreOrderDetailsModalProps> = ({
  open,
  handleClose,
  preOrderId,
}) => {
  const dispatch = useAppDispatch();
  const { dataPreOrder, loadingPreOrder, errorPreOrder } = useAppSelector(
    (state) => state.detailOrderSlice
  );

  useEffect(() => {
    if (preOrderId) {
      dispatch(fetchPreOrderDetails(preOrderId));
    }
  }, [dispatch, preOrderId]);
  const calculatedTotal = dataPreOrder?.Articles.reduce(
    (acc, article) => acc + article.Prix * article.Qte,
    0
  );
  

  return (
    <Dialog
      sx={{ "& .MuiDialog-paper": { width: "80%", maxWidth: "800px" } }}
      open={open}
      onClose={handleClose}
      aria-labelledby="preorder-details-dialog-title"
    >
      <DialogTitle id="preorder-details-dialog-title">
        Pré-commande Details
      </DialogTitle>
      <DialogContent dividers>
        {loadingPreOrder ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "200px",
            }}
          >
            <CircularProgress />
          </Box>
        ) : errorPreOrder ? (
          <Typography color="error">{errorPreOrder}</Typography>
        ) : dataPreOrder ? (
          <Box>
            <Typography display="flex" justifyContent="end" variant="h6">
              Client Code: {dataPreOrder.ClientCode}
            </Typography>
            <Typography display="flex" justifyContent="end" variant="h6">
              Nom Client: {dataPreOrder.ClientName}
            </Typography>
            <Typography variant="h6">Articles</Typography>
            <TableContainer component={Paper} sx={{ mt: 2 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Article</TableCell>
                    <TableCell>Quantity</TableCell>
                    <TableCell>Price</TableCell>
                    <TableCell>Commentaire</TableCell>
                    <TableCell>Type Article </TableCell>
                    <TableCell>Unit</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataPreOrder.Articles.map((article , index) => (
                    <TableRow key={index}>
                      <TableCell>{article.LibelleArticle}</TableCell>
                      <TableCell>{article.Qte}</TableCell>
                      <TableCell>{formatPrice(article.Prix)}</TableCell>
                      <TableCell>{article.Commentaire}</TableCell>
                      <TableCell>{article.TypeArticle}</TableCell>
                      <TableCell>{article.Unite}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Typography
              display="flex"
              justifyContent="end"
              mt={3}
              variant="h6"
            >{`Total: ${formatPrice(calculatedTotal ?? 0)} DHs TTC`}</Typography>
          </Box>
        ) : (
          <Typography>No details available.</Typography>
        )}
      </DialogContent>
      {/* <DialogActions>
      <Button onClick={handleClose} >
          Close
        </Button>
      </DialogActions> */}
    </Dialog>
  );
};

export default PreOrderDetailsModal;
